<template>
    <div class="auxiliar-select-wrapper">
        <div v-if="loading" class="form-control form-control-sm d-flex align-items-center gap-2 text-muted" style="min-height: 31px;">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
            <span class="small">Cargando...</span>
        </div>
        <Multiselect
            v-else
            :model-value="modelValue"
            :options="opciones"
            value-prop="idAuxiliar"
            label="descripcion"
            :object="true"
            :searchable="true"
            :can-clear="true"
            :placeholder="placeholder"
            :disabled="disabled"
            no-options-text="Sin opciones"
            no-results-text="Sin resultados"
            @update:model-value="emit('update:modelValue', $event)"
        />
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import Multiselect from '@vueform/multiselect'
import '@vueform/multiselect/themes/default.css'
import { auxiliaresApi } from '@/api/auxiliaresApi'
import type { Auxiliar } from '@/types/auxiliar'

const props = withDefaults(defineProps<{
    modelValue: Auxiliar | null
    idTipoAuxiliar: string
    placeholder?: string
    disabled?: boolean
}>(), {
    placeholder: 'Seleccionar...',
    disabled: false,
})

const emit = defineEmits<{
    'update:modelValue': [value: Auxiliar | null]
}>()

const loading = ref(false)
const opciones = ref<{ idAuxiliar: string; descripcion: string | null }[]>([])

onMounted(async () => {
    loading.value = true
    try {
        opciones.value = await auxiliaresApi.getByTipo(props.idTipoAuxiliar)
    } finally {
        loading.value = false
    }
})
</script>

<style>
.auxiliar-select-wrapper .multiselect {
    --ms-font-size: 0.875rem;
    --ms-line-height: 1.5;
    --ms-py: 0.25rem;
    --ms-px: 0.5rem;
    --ms-min-height: 31px;
    --ms-ring-width: 0;
    --ms-ring-color: transparent;
    --ms-border-color-active: #86b7fe;
    --ms-option-font-size: 0.875rem;
    --ms-option-py: 0.25rem;
    --ms-option-px: 0.5rem;
}
</style>
